import Vue from 'vue'
import Router from 'vue-router'
// import Main from '../views/Main.vue'
import NotFound from '@/views/NotFound';
import layout from '@/views/layout';

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      //登录页
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        title: '登录',
        requiresAuth: false
      }
    },
    {
      //首页
      path: '/',
      name: 'layout',
      component: layout,
      redirect: 'dashboard',
      //子路由
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('@/views/dashboard.vue'),
          meta: {
            home: true,
            title: '首页',
            requiresAuth: true
          }
        },
        {
          //菜单管理
          path: '/menu',
          name: 'Menu',
          component: () => import('@/views/sys/menu/SysMenu'),
          meta: {
            title: '菜单管理',
            requiresAuth: true
          }
        },
        {
          //角色管理
          path: '/role',
          name: 'Role',
          component: () => import('@/views/sys/role/Role'),
          meta: {
            title: '角色管理',
            requiresAuth: true
          }
        },
        /*{
          //部门管理
          path: '/dept',
          name: 'Dept',
          component: () => import('@/views/sys/dept/Dept'),
          meta: {
            title: '部门管理',
            requiresAuth: true
          }
        },*/
        {
          //账号管理
          path: '/account',
          name: 'Account',
          component: () => import('@/views/sys/account/Account'),
          meta: {
            title: '账号管理',
            requiresAuth: true
          }
        },
        {
          //系统日志
          path: '/log',
          name: 'Log',
          component: () => import('@/component/sys-log/SysLog.vue'),
          meta: {
            title: '系统日志',
            requiresAuth: true
          }
        },
        {
          path: '/pl-community-list',
          name: 'pl-community-list',
          component: () => import('@/views/pl-community-list.vue'),
          meta: {
            title: '社区清单',
            requiresAuth: true
          }
        },
        {
          path: '/wechat-user-list',
          name: 'wechat-user-list',
          component: () => import('@/views/wechat-user-list.vue'),
          meta: {
            title: '注册用户',
            requiresAuth: true
          }
        },
        {
          path: '/pl-plot-list',
          name: 'pl-plot-list',
          component: () => import('@/views/pl-plot-list.vue'),
          meta: {
            title: '地块管理',
            requiresAuth: true
          }
        },
        {
          path: '/pl-agreement-list',
          name: 'pl-agreement-list',
          component: () => import('@/views/pl-agreement-list.vue'),
          meta: {
            title: '协议管理',
            requiresAuth: true
          }
        },
        {
          path: '/pl-veg-list',
          name: 'pl-veg-list',
          component: () => import('@/views/pl-veg-list.vue'),
          meta: {
            title: '社区菜园清单',
            requiresAuth: true
          }
        },
        {
          path: '/pl-apply-list',
          name: 'pl-apply-list',
          component: () => import('@/views/pl-apply-list.vue'),
          meta: {
            title: '申请记录',
            requiresAuth: true
          }
        },
        {
          path: '/pl-apply-review-list',
          name: 'pl-apply-review-list',
          component: () => import('@/views/pl-apply-review-list.vue'),
          meta: {
            title: '审核中心',
            requiresAuth: true
          }
        },
        {
          path: '/pl-deposit-list',
          name: 'pl-deposit-list',
          component: () => import('@/views/pl-deposit-list.vue'),
          meta: {
            title: '退款清单',
            requiresAuth: true
          }
        },
        {
          path: '/pl-manage-fee-list',
          name: 'pl-manage-fee-list',
          component: () => import('@/views/pl-manage-fee-list.vue'),
          meta: {
            title: '收款清单',
            requiresAuth: true
          }
        },
        {
          path: '/pl-adjust-list',
          name: 'pl-adjust-list',
          component: () => import('@/views/pl-adjust-list.vue'),
          meta: {
            title: '调整分配',
            requiresAuth: true
          }
        },
        {
          path: '/pl-msg-template-list',
          name: 'pl-msg-template-list',
          component: () => import('@/views/pl-msg-template-list.vue'),
          meta: {
            title: '消息模版',
            requiresAuth: true
          }
        },
        {
          path: '/pl-msg-list',
          name: 'pl-msg-list',
          component: () => import('@/views/pl-msg-list.vue'),
          meta: {
            title: '消息管理',
            requiresAuth: true
          }
        },
        {
          path: '/pl-plot-statistics-list',
          name: 'pl-plot-statistics-list',
          component: () => import('@/views/pl-plot-statistics-list.vue'),
          meta: {
            title: '地块使用统计',
            requiresAuth: true
          }
        },
        {
          path: '/pl-plot-claim-status-list',
          name: 'pl-plot-claim-status-list',
          component: () => import('@/views/pl-plot-claim-status-list.vue'),
          meta: {
            title: '认领情况明细表',
            requiresAuth: true
          }
        },
        {
          path: '/pl-deposit-statistics-list',
          name: 'pl-deposit-statistics-list',
          component: () => import('@/views/pl-deposit-statistics-list.vue'),
          meta: {
            title: '押金月度汇总统计',
            requiresAuth: true
          }
        },
        {
          path: '/pl-mng-fee-statistics-list',
          name: 'pl-mng-fee-statistics-list',
          component: () => import('@/views/pl-mng-fee-statistics-list.vue'),
          meta: {
            title: '管理费月度汇总统计',
            requiresAuth: true
          }
        },
        {
          path: '/pl-transaction-detail-list',
          name: 'pl-transaction-detail-list',
          component: () => import('@/views/pl-transaction-detail-list.vue'),
          meta: {
            title: '申请单收支明细表',
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '*',
      component: NotFound,
      meta: {
        title: '404',
        requiresAuth: false
      }
    }
  ]
})